import React from 'react';

const Copyright = () => {
  const currentDate = new Date().getFullYear();

  return <>© {currentDate} Hedron Network</>;
};

export default Copyright;
